import { ConversationBase } from '../../../conversations/common/models/conversation-base.model';
import { WorkItemIntegration } from '../work-item-integrations.model';

export const smartAdvisorIntegration: WorkItemIntegration = {
  id: 'smart-advisor',
  svgIconName: 'smart-advisor',
  tooltip: 'tooltips.gcSmartAdvisorIntegration',
  title: 'tooltips.gcSmartAdvisorIntegration',
  parseUrl: (conversation: ConversationBase, gcDomain: string, locale: string): string => {
    return `https://apps.${gcDomain}/smart-advisor-ui/#/smart-advisor?host=pc&locale=${locale}&iid=${conversation.id}`;
  },
  permissions: []
};
